export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7245.4c725938.jpg";